export default {
    info: 'Info',
    confirm: 'Confirm'
}
